import styled from "styled-components";

export const TabsContainer = styled.div`
  width: 100%;
`;

